export const auditColumns = [
    {
        field: "date",
        headerName: "Date",
        width: 120,
    },
    {
        field: "staffInOut",
        headerName: "Staff In Out",
        width: 160,
    },
    {
        field: "whatsAppStatus",
        headerName: "WhatsApp Status",
        width: 160
    },
    {
        field: "whatsAppBroadcast",
        headerName: "WhatsApp Broadcast",
        width: 160
    },
    {
        field: "hygieneCheck",
        headerName: "Hygiene Check",
        width: 160
    },
    {
        field: "addWhatsAppContact",
        headerName: "Add Whatsapp Contact",
        width: 160,
    },
    {
        field: "airPercentageCheck",
        headerName: "Air Percentage",
        width: 160,
    },
    {
        field: "turnedOnLights",
        headerName: "Turned On Lights",
        width: 160,
    },
    {
        field: "cashHandover",
        headerName: "Cash Handover",
        width: 120,
    },
    {
        field: "absentSmsCalls",
        headerName: "Abent Sms Calls",
        width: 120,
    },
    {
        field: "followUpCalls",
        headerName: "Followup Calls",
        width: 120,
    },
    {
        field: "turnedOffLights",
        headerName: "Turned Off Lights",
        width: 120,
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
  ];